import axios from 'axios';
import { mutate } from 'swr';

import { DealProduct } from '@modules/ContactManager/components/Tabs/components/Deals/components/Products/interfaces';
import { queryParams } from '@shared/commonFunctions';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';

import { IUpdateProductRetail } from '../../../../interfaces';

export interface IAddRequestDeal {
  lenderCode?: string;
  rate?: number;
  term: number;
  loanAmount: number;
  type: number;
  dealUsers: null;
  isPreApproval: boolean;
  assetId: string;
  products: DealProduct[];
  cashout: number;
  downPayment: number;
  rateMarkUp: number;
  netRate: number;
  totalAmountFinanced: number;
  salesTaxPercentage: number;
}

export const requestIncludeLender = (lenderCode: string, leadId: string) => {
  const path = `/${SERVICES.LEAD}/leads/${leadId}`;

  return mutate(`${path}/dealCalculator`, async() => {
    try {
      await axios.put(`${path}/dealcalculator/lender/${lenderCode}/include`);
      Notistack.successMessage('Lender - Include Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestExcludeLender = (lenderCode: string, leadId: string, reason: string, updateComment = false) => {
  const path = `/${SERVICES.LEAD}/leads/${leadId}`;

  return mutate(`${path}/dealCalculator`, async() => {
    try {
      await axios.put(`${path}/dealcalculator/lender/${lenderCode}/exclude`, reason, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      Notistack.successMessage(updateComment ? 'Lender - Exclude Comment Updated Successfully' : 'Lender - Exclude Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateProductRetail = (data: IUpdateProductRetail) => {
  const path = `/${SERVICES.LEAD}/leads/${data.leadId}`;

  return mutate([`${path}/dealCalculator`], async() => {
    try {
      await axios.put(`/${SERVICES.PRODUCT}/dealcalculator/retail`, data);
      Notistack.successMessage(data.productTypeName.toUpperCase() + ' Retail - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpsertDeal = async (leadId: string, dealId: string, deal: IAddRequestDeal, isDraftDeal = false) => {
  const params = queryParams();
  const contactId = params.id;

  const path = `/${SERVICES.DEAL}/contacts/${contactId}`;

  try {
    const resp = await axios.post(`${path}/leads/${leadId}/upsert/deals${(isDraftDeal && dealId) ? `?dealId=${dealId}` : ''}`, deal);
    Notistack.successMessage(`Deal - ${isDraftDeal ? 'Updated' : 'Added'} Successfully`);

    return resp?.data;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};



export const requestActualDTI = async (
  leadId: string,
  monthlyPaymentAmount: number,
  preferredBureau: string,
  defaultBureau: string
) => {
  const params = queryParams();
  const contactId = params.id;
  const assetId = params.assetId;
  const path = `/${SERVICES.LEAD}/leads/${leadId}`;
  try {
    const resp = await axios.post(`${path}/dealcalculator/ActualDti`, {
      contactId: contactId,
      assetId: assetId,
      monthlyPaymentAmount: monthlyPaymentAmount,
      preferredBureau: preferredBureau,
      defaultBureau: defaultBureau,
    });

    return resp?.data;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};
